import axios from '../axios';

const requestsAPI = {
  getAll: async ({ startDate, endDate } = {}) => {
    const response = await axios.get('/requests', {
      params: {
        ...(startDate ? { startDate } : {}),
        ...(endDate ? { endDate } : {}),
      },
    });
    return response.data;
  },

  updateStatus: async (rqstSn, status) => {
    const response = await axios.put(`/requests/${rqstSn}/status`, { status });
    return response.data;
  },

  create: async (payload) => {
    const response = await axios.post('/requests', payload);
    return response.data;
  },

  getWarnings: async ({ personId, officeUserUuid } = {}) => {
    const response = await axios.get('/requests/warnings', {
      params: {
        personId,
        ...(officeUserUuid ? { officeUserUuid } : {}),
      },
    });
    return response.data;
  },

  upload: async (rqstSn, formData) => {
    const response = await axios.post(`/files/${rqstSn}`, formData,
      {
        headers: {
          'Content-Type': undefined,
        },
      }
    );
    return response.data;
  },

  uploadSignature: async (rqstSn, formData) => {
    const response = await axios.post(`/files/${rqstSn}/signature`, formData,
      {
        headers: {
          'Content-Type': undefined,
        },
      }
    );
    return response.data;
  },

  getFiles: async (rqstSn) => {
    const response = await axios.get(`/files/${rqstSn}`);
    return response.data;
  },

  getFileDownloadUrl: async (fileUuid, { inline } = {}) => {
    const response = await axios.get(`/files/${fileUuid}/url`, {
      params: inline ? { inline: '1' } : {},
    });
    return response.data;
  },

  deleteFile: async (fileUuid) => {
    const response = await axios.delete(`/files/${fileUuid}`);
    return response.data;
  },
};

export default requestsAPI;

